import React, { useState, useEffect } from 'react';
import ContenedorMenu from './ContenedorMenu';
import Post from '../../../../utils/Post';
const ContenedorPerfil = (p) => {
    const select = p.select;
    const relacion = p.relacion;
    const index = p.index;
    const [nuevo, setnuevo] = useState({ submenu: '', menu: '' });

    const changeVal = (e) => {
        let { name, value } = e.target;
        setnuevo({ ...nuevo, [name]: value });
    }

    const menusExistentes = () => {
        let menus = [];
        let nombres = [];
        let subs = relacion.menus;
        let len = subs.length;
        for (let i = 0; i < len; i++) {
            let nombre = subs[i].menu_nombre.toUpperCase();
            if (nombres.includes(nombre)) continue;
            nombres.push(nombre);
            menus.push({ nombre: nombre, id: subs[i].menu_id });
        }
        return nombres;
    }

    const menusNoExistentes = () => {
        let len = p.menus.length;
        let existentes = menusExistentes();
        let noAgregados = [];
        for (let i = 0; i < len; i++) {
            let nombre = p.menus[i].nombre;
            if (existentes.includes(nombre)) continue;
            noAgregados.push(p.menus[i]);
        }
        return noAgregados;
    }
    const menus = menusNoExistentes();

    const agregar = async () => {
        let resp = await Post('secure/relaciones/add', { perfil: relacion.perfil_id, menu: nuevo.menu, submenu: nuevo.submenu }, 'POST', p.setloader);
        if (resp.estatus) p.refresh();
    }

    return (
        <div className={`w-100 mb-2 mt-2 p-2 round-s ${select.perfil === index ? ' border border-3 border-black bg-white' : ' bg-white3 shadow '} `}
            id={`perfil${index}`}>

            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className={`w-100 text-bold text-l ${select.perfil === index ? 'text-start' : 'text-center'}`}>
                    <div className='row justify-content-between w-100 m-0 p-0'>
                        <div className='bw-500 text-start'>
                            <span className={`text-300 text-s me-3`}>Tipo de perfil</span>{relacion.perfil_nombre}
                        </div>
                        <div className='bw-200 text-end contenedor'>
                            <button className={`w-100 btn btn-sm text-bold border round-xxl shadow-sm pt-0 pb-0 ${select.perfil === index ? "btn-danger" : "btn-warning"}`}
                                onClick={() => {
                                    if (select.perfil === index) return p.cerrar();
                                    else p.abrir('perfil', index);
                                }}
                            >{select.perfil === index ? 'Cerrar detalles' : "Ver detalles"}</button>
                        </div>

                    </div>

                </div>

                {/* MENUS DIPONIBLES PARA EL PERFIL UNA VEZ SE SELECCIONA */}
                {select.perfil === index && <>

                    <div className='w-100 mb-2 text-start'>
                        <div className='w-70 border-bottom border-warning round-xxl'></div>
                    </div>
                    {relacion.menus.map((menu, i) =>
                        <React.Fragment key={p.keyGen()}>
                            <ContenedorMenu select={select} menu={menu} index={index} abrir={p.abrir} refresh={p.refresh} submenus={p.submenus} setloader={p.setloader} keyGen={p.keyGen} />
                        </React.Fragment>
                    )}
                    <div className='w-100 mt-4 mb-2 text-xxl text-center'>
                        Agregue nuevo menú
                        <div className='text-s text-300 text-center'>Seleccione un  menú y una sección para hacer disponible un nuevo menú para este tipo de usuario</div>
                    </div>

                    <div className='form-group bw-400 mb-2'>
                        <select className='form-control form-control-sm shadow border round-xxl text-center text-bold'
                            name='menu'
                            value={nuevo.menu}
                            onChange={changeVal}>
                            <option value='' >Seleccione un menú</option>
                            {menus.map((menu, i) =>
                                <option key={p.keyGen()} value={menu.id}>{menu.nombre}</option>
                            )}
                        </select>
                    </div>

                    <div className='form-group bw-400 mb-2'>
                        <select className='form-control form-control-sm shadow border round-xxl text-center text-bold'
                            name='submenu'
                            value={nuevo.submenu}
                            onChange={changeVal}>
                            <option value='' >Seleccione una sección</option>
                            {p.submenus.map((submenu, i) =>
                                <option key={p.keyGen()} value={submenu.id}>{submenu.nombre}</option>
                            )}
                        </select>
                    </div>
                    <div className='form-group bw-300 mb-2 contenedor'>
                        <button className='w-100 btn btn-sm text-bold btn-warning shadow border border-2 border-dark round-xxl'
                            type='button'
                            onClick={agregar}
                            disabled={nuevo.menu == "" || nuevo.submenu == ""}>Agregar</button>
                    </div>
                </>}
            </div>
        </div>
    )
}

export default ContenedorPerfil;